import { graphql, Slice, useStaticQuery } from 'gatsby';
import React, { type FC } from 'react';

import { Html } from '@/components/content/html';
import { Logo } from '@/components/icons/logo';
import { ParamLink } from '@/components/links/param-link';

interface FooterQuery {
    footer: Graphql.Footer;
}

const year = new Date().getFullYear();

export const Footer: FC = () => {
    const { footer } = useStaticQuery<FooterQuery>(graphql`
        query Footer {
            footer {
                description {
                    html
                }
            }
        }
    `);

    return (
        <footer
            style={{ margin: 'clamp(40px, 6vw, 80px) 0 clamp(16px, 2.8vw, 36px)' }}
            className="footer box bg-gray py-80"
        >
            <div className="container">
                <Logo theme="secondary" />

                <div style={{ gap: '30px 120px', marginTop: 'clamp(24px, 2.8vw, 36px)' }} className="d-flex flex-wrap">
                    <nav>
                        <ul className="list unstyled-list">
                            <li>
                                <ParamLink to="/imprumut-fara-anaf/" className="link fs-18">
                                    Credit rapid fără ANAF
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumut-rapid-cu-buletinul/" className="link fs-18">
                                    Împrumut rapid cu buletinul
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumut-fara-adeverinta-venit/" className="link fs-18">
                                    Împrumut fără adeverință de venit
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumuturi-online/" className="link fs-18">
                                    Împrumuturi online rapide și sigure
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumuturi-pentru-indatorati/" className="link fs-18">
                                    Împrumuturi pentru persoane cu datorii
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumuturi-cu-plata-instantanee/" className="link fs-18">
                                    Împrumut cu plata instantanee
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/imprumuturi-pentru-firme/" className="link fs-18">
                                    Împrumuturi pentru firme și PFA-uri
                                </ParamLink>
                            </li>

                            <li style={{ marginTop: '12px' }}>
                                <ParamLink to="/contact/" className="link fs-18">
                                    Contactează Loando
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/partenerii/" className="link fs-18">
                                    Partenerii Loando
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/despre-noi/" className="link fs-18">
                                    Despre proiectul Loando
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/politica-de-confidentialitate/" className="link fs-18">
                                    Politica de confidențialitate pentru Loando
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/politica-de-cookie/" className="link fs-18">
                                    Politica de cookie pentru Loando
                                </ParamLink>
                            </li>

                            <li>
                                <ParamLink to="/termeni-si-conditii/" className="link fs-18">
                                    Termeni și condiții pentru Loando
                                </ParamLink>
                            </li>
                        </ul>
                    </nav>

                    {footer.description?.html && (
                        <div style={{ flex: '1 1 650px' }}>
                            <Html className="fs-14">{footer.description?.html}</Html>
                        </div>
                    )}

                    <Slice allowEmpty alias="footer-extra" />

                    <b>{year} &copy; Loando.ro. Toate drepturile rezervate.</b>
                </div>
            </div>
        </footer>
    );
};
